import React from "react";
import GetPriceByEmail from "./GetPriceByEmail";
import { VariantProps } from ".";
import LoginLink from "./LoginLink";

const E = ({ selectedProduct, productListingView }: VariantProps) => {
  return (
    <div className="map map-override mapE">
      {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ? (
        <p className="price enter-email">
          {"Contact us or "}
          <LoginLink>
            <span className="text__link">login</span>
          </LoginLink>
          <br />
          {" for details"}
        </p>
      ) : (
        <p className="price enter-email">Contact us for details</p>
      )}
      <p className="to-see-price noborder mb-2">Call 717-392-7472</p>
      <p className="to-see-price" />
      <div className="input-append">
        <GetPriceByEmail
          itemNumber={selectedProduct.itemNumber}
          className={
            productListingView === "list"
              ? "justify-start xs:justify-center"
              : "justify-center"
          }
        />
      </div>
    </div>
  );
};

export default E;
